// extracted by mini-css-extract-plugin
export default {"title":"ChooseUs_title__wWqc+","advantages":"ChooseUs_advantages__6ah2a"};